import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { LinkWidgetConfig } from './model';
import { resolveWidgetTextColor } from '../../helpers/widget-color.helper';

@Component({
  selector: 'app-link-widget',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule, TranslateModule],
  templateUrl: './link-widget.component.html',
  styleUrl: './link-widget.component.scss',
})
export class LinkWidgetComponent {
  @Input() value: any = '';
  @Input() action?: (value: any) => void; // Action callback function (required)
  @Input() tooltip?: string | ((value: any) => string); // Optional tooltip as string or function
  @Input() icon?: string; // Optional icon (e.g., "edit", "delete", "file_download")
  @Input() color?: string; // Optional color (e.g., "#FF5733", "primary")
  @Input() translate: boolean = false; // Flag to enable i18n
  @Input() translationPrefix?: string; // Translation prefix from grid

  /**
   * Handle click event - executes the action callback
   */
  onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.action) {
      this.action(this.value);
    }
  }

  /**
   * Get the tooltip key for template
   * If tooltip is a function, call it with the value
   * If translate=true with translationPrefix, build full translation key for both string and callback results
   * Otherwise return as-is
   */
  get tooltipKey(): string | null {
    if (!this.tooltip) return null;

    // If tooltip is a function, call it
    const tooltipValue =
      typeof this.tooltip === 'function'
        ? this.tooltip(this.value)
        : this.tooltip;

    // If translate is enabled and we have a prefix, build full translation key
    if (this.translate && this.translationPrefix) {
      return `${this.translationPrefix}.${tooltipValue}`;
    }

    return tooltipValue;
  }

  /**
   * Get the display value (convert to string and capitalize first letter)
   */
  getDisplayValue(): string {
    return this.value ? String(this.value).toUpperCase() : '';
  }

  getLinkColor(): string {
    return resolveWidgetTextColor({
      color: this.color,
    });
  }
}
